import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";

import { StatusCode } from "api/protocols";

import Page from "components/page/Page";
import Card from "components/card/Card";
import FormLayout from "components/form/FormLayout";
import Form from "components/form/Form";
import Input from "components/form/input/Input";
import { Select } from "components/select/index";
import { useTranslation, Trans } from "react-i18next";
import { PostPrinter } from "api/rpc/2024-04/facilityAdmin/facility/printer";

interface IProps {
  uiActions: any;
}
interface IStatePrinter {
  id: number;
  title: string;
  brand: string;
  ip_address: string;
  port: string;
}

export default function PrinterNew(props: IProps) {
  const { uiActions } = props;
  const { Option } = Select;

  const history = useHistory();

  const { t, i18n } = useTranslation();

  const primaryAction = {
    content: t("Create"),
    action: createPrinter,
  };

  const [printerState, setPrinterState] = useState({
    title: "",
    brand: "",
    ip_address: "",
    port: "",
  });

  async function createPrinter() {
    const res = await PostPrinter(printerState, true);
    if (res.status === StatusCode.OK) {
      uiActions.showSuccess(t("Printer created successfully"));
    } else {
      uiActions.showError(res.data.message);
    }

    history.push("/admin/settings/printers");
  }

  function handleInputChange(event: any) {
    const { id, value } = event.target;
    setPrinterState(prevState => ({ ...prevState, [id]: value }));
  }

  return (
    <Page
      title={t("New Printer")}
      narrow
      primaryAction={primaryAction}
      breadcrumbs={[
        { prefix: true, label: t("Back to printers"), url: "/admin/settings/printers" },
      ]}
    >
      <Card>
        <Card.Section>
          <Form>
            <FormLayout>
              <FormLayout.Group>
                <Input
                  value={printerState.title}
                  label={t("Title")}
                  id="title"
                  onChange={handleInputChange}
                  placeholder={t("Title")}
                />
                <Input
                  value={printerState.brand}
                  label={t("Brand")}
                  id="brand"
                  onChange={handleInputChange}
                  placeholder={t("Brand")}
                />
              </FormLayout.Group>
              <FormLayout.Group>
                <Input
                  value={printerState.ip_address}
                  label={t("IP Address")}
                  id="ip_address"
                  onChange={handleInputChange}
                  placeholder="000.000.000.000"
                />
                <Input
                  value={printerState.port}
                  label={t("Port")}
                  id="port"
                  onChange={handleInputChange}
                  placeholder="8080"
                />
              </FormLayout.Group>
            </FormLayout>
          </Form>
        </Card.Section>
      </Card>
    </Page>
  );
}
